<template>
  <div class="auth-container row middle-xs center-xs">
    <div class="col-xs-10 auth-form">
      <div class="row">
        <div class="col-xs-6 p0">
          <img :src="`/assets/img/square.png`" class="logo" />
        </div>
        <div class="col-xs input-box">
          <div class="row">
            <span class="title">Login</span>
          </div>
          <div class="row">
            <google-sign-in-button
              :o-auth-url-host="oauthUrlHost"
              class="google-signin row center-xs middle-xs plain"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import googleSignInButton from "../components/elements/google-sign-in-button.vue";

export default {
  components: { googleSignInButton },
  data() {
    return {
      // unify auth host usage: derive host from VUE_APP_AUTH_URL (strip trailing /api if present)
      oauthUrlHost: (process.env.VUE_APP_AUTH_URL || "").replace(/\/api$/, ""),
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "authentication/isAuthenticated",
    }),
  },
  watch: {
    isAuthenticated(val) {
      if (val && this.$route.path !== "/") return this.$router.replace("/");
    },
  },
};
</script>
<style lang="scss" scoped>
.yellow {
  height: 380px;
  background-color: $primary;
}
.auth-form {
  padding: 0;
  box-shadow: 0px 0px 30px 15px #f5f5f5f5;
}
.input-box {
  padding: 30px;
  .title {
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
.google-signin {
  -webkit-box-sizing: border-box;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  box-sizing: border-box;
  -webkit-box-align: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  justify-content: center;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  max-width: 100%;
  height: 50px !important;
  padding: 0 8px;
  line-height: 50px !important;
  color: #42526e !important;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  vertical-align: middle;
  cursor: default;
  background: rgba(255, 255, 255, 0.5) none repeat scroll 0 0 !important;
  border-width: 0;
  border-radius: 9px;
  outline: medium none currentcolor !important;
  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 5px 0 !important;
  box-shadow: 1px 1px 8px 0 rgba(0, 70, 110, 0.2) !important;
  -webkit-transition: background 0.1s ease-out 0s,
    -webkit-box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  transition: background 0.1s ease-out 0s,
    -webkit-box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  transition: background 0.1s ease-out 0s,
    box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  transition: background 0.1s ease-out 0s,
    box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s,
    -webkit-box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
}
::v-deep .google-signin .signin {
  font-family: "Manrope", sans-serif;
  font-size: 14px;
}
.google-signin:hover {
  background-color: rgba(255, 255, 255, 1) !important;
}
.google-logo {
  position: relative;
  margin-right: 15px;
  top: 4px;
}
.auth-container {
  padding-bottom: 70px;
}
</style>
